<template>
    <div v-if="player" class="player-card-border bg-gradient-default" :style="dynamicStyles">        <div class="player-card">
            <div class="player-image-container">
                <canvas ref="playerCanvas" class="player-image-canvas"></canvas>
            </div>
            <div class="player-name text-default" ref="playerNameContainer">
                {{ player.name.toUpperCase() }}
            </div>

            <div class="player-details">
                <img :src="player.nationality_flag" :alt="player.nationality.slice(0, 2).toUpperCase()"
                    class="detail-container">
                <img v-if="currentClub && currentClub.current_league && currentClub.current_league.logo"
                    :src="currentClub.current_league.logo" :alt="currentClub.current_league.name" class="detail-container">
                <div class="detail-container">
                    <img :src="currentClub.logo_url" alt="Club Logo" class="club-logo">
                </div>
            </div>
        </div>
    </div>
</template>


  
<script>
// @ts-ignore
import ResizeText from 'vue-resize-text'
export default {
    directives: {
        ResizeText
    },
    props: {
        selectedGamePlayer: {
            type: Object,
            default: () => { }
        }
    },
    mounted() {
        this.updateBaseSize();
        window.addEventListener('resize', this.updateBaseSize);
        this.$nextTick(() => {
            this.removeBackground();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateBaseSize);
        },
    watch: {
        // Watch for changes in the 'player' object
        player: {
            deep: true, // Make sure to react to any nested property changes
            handler() {
                // Re-run the background removal function
                this.removeBackground();
            }
        },
    },
    methods: {
        async removeBackground() {
            const img = new Image();
            img.crossOrigin = 'anonymous'; // To handle CORS issues if applicable
            img.src = this.player.photo_url;

            await img.decode(); // Wait for image to be loaded

            const canvas = this.$refs.playerCanvas;
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            // Get the top-left pixel color
            const refRed = data[0];
            const refGreen = data[1];
            const refBlue = data[2];

            for (let i = 0; i < data.length; i += 4) {
                const red = data[i];
                const green = data[i + 1];
                const blue = data[i + 2];

                // Calculate the color difference
                const colorDiff = Math.sqrt(Math.pow((refRed - red), 2) + Math.pow((refGreen - green), 2) + Math.pow((refBlue - blue), 2));

                // If the color is similar to the top-left corner, make it transparent
                if (colorDiff < 15) { // Add a 'feathering' zone
                    // Feather the edge by adjusting the alpha channel
                    data[i + 3] = ((colorDiff) / 55) * 255;
                }
            }

            ctx.putImageData(imageData, 0, 0);
        },
        updateBaseSize() {
            // Use this.$el to access the element, or provide a ref to the container
            const containerWidth = this.$el.clientWidth;
            const containerHeight = this.$el.clientHeight;

            // Set a base size relative to the container size (e.g., 10% of the width)
            const baseSize = Math.min(containerWidth, containerHeight) * 0.1; // Or any other factor you prefer
            const fontSize = containerWidth * 0.09; // Adjust 0.05 (5%) as needed

            this.dynamicStyles = {
                '--base-size': `${baseSize}px`,
                '--dynamic-font-size': `${fontSize}px`
            };
        }
    },
    data() {
        return {
            dynamicStyles: {},
        };
    },
    computed: {
        player() {
            return this.selectedGamePlayer.player;
        },
        currentClub() {
            if (this.player.transfers.length) {
                let lastTransfer = this.player.transfers.reduce((latest, transfer) => {
                    return new Date(transfer.transfer_date) > new Date(latest.transfer_date) ? transfer : latest;
                });
                return lastTransfer.to_team;
            }
            return {};
        }
    }
};
</script>
  
<style scoped>
.player-card-border {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(var(--base-size) * 0.7) calc(var(--base-size) * 0.7) calc(var(--base-size) * 2.1) calc(var(--base-size) * 2.1);
    box-shadow: 0 0 calc(var(--base-size) * 2) rgba(0, 0, 0, 0.5);
    overflow: hidden;
    padding: 2px;
}

.player-card {
    width: 100%;
    height: 100%;
    padding: calc(var(--base-size) * 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: relative;
    pointer-events: none;
    user-select: none;
    background: radial-gradient(ellipse at top, #fbf7a0, #be953d);
    border-radius: calc(var(--base-size) * 0.6) calc(var(--base-size) * 0.6) calc(var(--base-size) * 2) calc(var(--base-size) * 2);
}

.player-image-container {
    width: 80%;
    height: 53.33%;
    flex: 0 0 auto;
    padding-top: calc(var(--base-size));
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.player-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.player-image-canvas {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.player-name {
    width: 100%;
    font-weight: bold;
    white-space: normal;
    text-align: center;
    margin-top: 2%;
    margin-bottom: 2%;
    font-size: var(--dynamic-font-size, 1rem);
}


.player-details {
    width: 80%;
    height: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.detail-container {
    width: 20%;
}

.club-logo {
    width: 100%;
}
</style>
  